// Utility to build canonical URLs without hash fragments during SSR/CSR.
const getCanonicalUrl = (fallbackUrl) => {
  if (typeof window === 'undefined') {
    return fallbackUrl;
  }

  const { origin, pathname, search } = window.location;
  return `${origin}${pathname}${search}`;
};

export default getCanonicalUrl;
